export function numberToIndianWords(amount) {
  if (amount === null || amount === undefined || isNaN(amount))
    return "Rupees Zero Only";

  // Split rupees and paise
  let [rupees, paise] = Number(amount).toFixed(2).split(".");
  rupees = Number(rupees);
  paise = Number(paise);

  const a = [
    "", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine",
    "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen",
    "Sixteen", "Seventeen", "Eighteen", "Nineteen"
  ];

  const b = [
    "", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy",
    "Eighty", "Ninety"
  ];

  function twoDigits(n) {
    if (n < 20) return a[n];
    return b[Math.floor(n / 10)] + (n % 10 ? " " + a[n % 10] : "");
  }

  function threeDigits(n) {
    if (n < 100) return twoDigits(n);
    return (
      a[Math.floor(n / 100)] +
      " Hundred" +
      (n % 100 ? " " + twoDigits(n % 100) : "")
    );
  }

  function convertRupees(num) {
    if (num === 0) return "Zero";

    let words = "";

    let crore = Math.floor(num / 10000000);
    if (crore > 0) words += threeDigits(crore) + " Crore ";
    num %= 10000000;

    let lakh = Math.floor(num / 100000);
    if (lakh > 0) words += threeDigits(lakh) + " Lakh ";
    num %= 100000;

    let thousand = Math.floor(num / 1000);
    if (thousand > 0) words += threeDigits(thousand) + " Thousand ";
    num %= 1000;

    let hundred = Math.floor(num / 100);
    if (hundred > 0) words += a[hundred] + " Hundred ";
    num %= 100;

    if (num > 0) words += twoDigits(num);

    return words.trim();
  }

  // Convert rupees to words
  let rupeeWords = convertRupees(rupees);

  // Convert paise to words
  let paiseWords =
    paise > 0 ? twoDigits(paise) + " Paise" : "";

  // Final formatting
  if (paiseWords) {
    return `Rupees ${rupeeWords} and ${paiseWords} Only`;
  } else {
    return `Rupees ${rupeeWords} Only`;
  }
}
